import request from 'helpers/request';
import api from 'config';

// 월별 식대 금액
export const MonthlyStatus = () =>
  request({
    url: `${api.config.companyAPI}/stat/v1/coupon/month`
  });

// 일별 식대 금액
export const DailyStatus = () =>
  request({
    url: `${api.config.companyAPI}/stat/v1/coupon/day`
  });

// 시간대별 사용 현황
export const HourlyStatus = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/coupon/hour`,
    params
  });

// 가맹점 사용금액 TOP 5
export const StoreTopList = () =>
  request({
    url: `${api.config.companyAPI}/stat/v1/store/top`
  });

// 부서 사용금액 TOP 5
export const DepartmentTopList = () =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/division/top`
  });

// 메뉴 TOP 5
export const MenuTopList = () =>
  request({
    url: `${api.config.companyAPI}/stat/v1/store/menu/top`
  });
